"use client";
import { useEffect } from "react";

const config = {
  companyName: "LockedIn",
  description:
    "LockedIn is a unique app that tracks the time until you turn 60. It features a countdown grid, motivational quotes, and clocks to inspire you to make the most of each moment. Add Task & Goals here. Stay focused on your goals and embrace the journey ahead!",
  siteURL: "https://offerbutton.com",
  companyId: "506951f4-c17a-4129-aaac-e7d523aa9325",
  position: "bottom-right",
};

const positions = {
  "top-left": "top: 12px; left: 12px;",
  "top-center": "top: 12px; left: 50%; transform: translateX(-50%);",
  "top-right": "top: 12px; right: 12px;",
  "bottom-left": "bottom: 12px; left: 12px;",
  "bottom-center": "bottom: 12px; left: 50%; transform: translateX(-50%);",
  "bottom-right": "bottom: 12px; right: 12px;",
};

const OfferButton = () => {
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@500;600;700&display=swap');
      
      body {
        background: linear-gradient(135deg, #ff7eb3, #ff758c, #ff677d);
        background-size: cover;
        background-attachment: fixed;
        color: #ffffff;
        font-family: 'IBM Plex Sans', sans-serif;
        margin: 0;
        padding: 0;
      }
      
      .offer-button-container {
        position: relative;
        overflow: hidden;
      }
      
      .offer-button {
        background: linear-gradient(90deg, #34e89e, #0f3443);
        color: #ffffff;
        border: none;
        padding: 12px 24px;
        font-size: 16px;
        border-radius: 11px;
        cursor: pointer;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        transition: background 0.3s ease, transform 0.2s ease;
        position: relative;
        z-index: 1;
      }
      
      .offer-button:hover {
        background: linear-gradient(90deg, #0f3443, #34e89e);
        transform: scale(1.05);
      }
      
      .offer-button:active {
        background: linear-gradient(90deg, #28527a, #11998e);
      }
      
      .card {
        text-align: center;
        border-radius: 16px;
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25), 0 3px 4px rgba(0, 0, 0, 0.05);
        width: 285px;
        position: relative;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.1);
      }
      
      .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        background: #ff5252;
        border: none;
        height: 24px;
        width: 24px;
        border-radius: 50%;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      h1 {
        font-size: 24px;
        font-weight: 600;
        color: #ffffff;
        margin: 0;
      }
      
      .description {
        color: #B0BEC5;
        font-size: 14px;
        margin-top: 12px;
        line-height: 20px;
      }
      
      .offer-section {
        padding: 21px;
        position: relative;
      }
    `;
    document.head.appendChild(styleElement);

    const container = document.createElement("div");
    container.style.cssText = `position: fixed; z-index: 9999; ${
      positions[config.position] || positions["bottom-right"]
    }`;

    container.innerHTML = `
      <div class="card">
        <button class="close-button" onclick="this.parentElement.parentElement.style.display='none'">×</button>
        <div style="padding: 30px 24px 0; border-bottom: 1px solid rgba(255, 255, 255, 0.2)">
          <h1>${config.companyName}</h1>
          <div class="description">${config.description}</div>
        </div>
        <div class="offer-section offer-button-container">
          <button class="offer-button" onclick="window.location.href='${config.siteURL}/company/${config.companyId}/offer'">
            <span style="background: #0066ff; color: white; width: 24px; height: 24px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; margin-right: 8px">$</span>
            Make an offer
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(container);

    return () => container.remove();
  }, []);

  return null;
};

export default OfferButton;
